/**
 * @fileoverview Foto de perfil de uma pessoa no estilo da lista de usuários:
 * círculo neutro com borda fina e as iniciais em cinza. Mostra a foto só
 * quando é foto de verdade; o boneco gerado (DiceBear), a imagem genérica
 * (nopicture) e a foto que não carrega caem nas iniciais, e sem nenhuma
 * palavra com letra no nome, no ícone de pessoa.
 */

import React from "react";
import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/core/styles";
import { User } from "lucide-react";

// Mesma regra do backend (GetSharedContactPicturesService).
const PLACEHOLDER_PICTURE = /dicebear\.com|nopicture\.png/i;

export const isRealPicture = (url) => Boolean(url) && !PLACEHOLDER_PICTURE.test(url);

/** Iniciais das duas primeiras palavras com letra ("4176900040 Ana Souza" → "AS"); sem nenhuma, "". */
export const avatarInitials = (name) =>
  String(name || "")
    .split(/\s+/)
    .filter((word) => /^\p{L}/u.test(word))
    .slice(0, 2)
    .map((word) => Array.from(word)[0])
    .join("")
    .toUpperCase();

const useStyles = makeStyles((theme) => {
  const dark = theme.palette.type === "dark";
  return {
    // Iniciais em tom neutro (sem cor por pessoa), nos dois temas.
    avatar: {
      flexShrink: 0,
      fontWeight: 700,
      background: dark ? "rgba(255,255,255,0.06)" : "#F4F4F5",
      color: dark ? "#A1A1AA" : "#52525B",
      border: `1px solid ${dark ? "rgba(255,255,255,0.10)" : "rgba(15,23,42,0.10)"}`,
    },
  };
});

const PersonAvatar = ({ name, src, size = 32 }) => {
  const classes = useStyles();
  const initials = avatarInitials(name);

  return (
    <Avatar
      src={isRealPicture(src) ? src : undefined}
      alt=""
      className={classes.avatar}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.375) }}
    >
      {initials || <User size={Math.round(size * 0.5)} />}
    </Avatar>
  );
};

export default PersonAvatar;
